import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    expanded = false;

    toggle() {
        this.expanded = !this.expanded;
        const scope = this.element.closest("main") || this.element.closest("[id='middle']") || document;
        const toggleElements = scope.querySelectorAll('[data-controller~="toggle"]');

        toggleElements.forEach((el) => {
            const controller = this.application.getControllerForElementAndIdentifier(el, "toggle");
            if (controller && controller.openValue !== this.expanded) {
                controller.toggle();
            }
        });
    }
}
